import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapCharts = React.lazy(function () {
    return import('../../bootstrap-components/components/BTCharts');
});
var bootStrapCharts = function (props) {
    return (React.createElement(BootStrapCharts, __assign({}, props)));
};
var Charts = function (props) {
    var componentToDisplay = bootStrapCharts(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapCharts(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
Charts.defaultProps = {
    styleName: 'success',
    ioTheme: themes[0],
    ioMode: 'light',
    width: 280,
    label: 'Percentage',
    series: [80]
};
export default React.memo(Charts);
//# sourceMappingURL=Charts.js.map